








































import { Component, Vue, Ref } from 'vue-property-decorator';
import Invoice from '@/components/Invoicing/Invoice/Invoice.vue';
import { CREATE_INVOICE } from '@/queries/Invoice';
import cloneDeep from 'lodash/cloneDeep';
import InvoiceNewControls from '@/components/Invoicing/Invoice/Controls/InvoiceNewControls.vue';
import { UnsavedChanges } from '@/decorators/unsaved-changes';
import i18n from '@/i18n';
import { AVAILABLE_LEGAL_NOTES, formatDataToMutationInput } from '@/app/Invoice';
import { GQL_newInvoiceData_newInvoice, GQL_newInvoiceData } from '@/queries/__generated__/newInvoiceData';
import { ALL_PAYMENT_METHODS } from '@/queries/PaymentMethod';
import { SmartQuery } from 'vue-apollo-decorator';
import { GQL_currentUnitPaymentMethods, GQL_currentUnitPaymentMethods_currentUnit_paymentMethods } from '@/queries/__generated__/currentUnitPaymentMethods';
import Decimal from '@/utils/decimal';
import gql from 'graphql-tag';
import { invoiceFragments } from '@/queries/invoiceFragments';

const NEW_INVOICE_DATA = gql`
  query newInvoiceData($orderIds: [ID!]!) {
    newInvoice(orderIds: $orderIds) {
      ...invoiceFragments
    }
  },
  ${invoiceFragments}
`;

@Component({
  components: {
    Invoice,
    InvoiceNewControls,
  },
})
export default class InvoicesNew extends Vue {
  public NEW_INVOICE_DATA = NEW_INVOICE_DATA;
  public cloneDeep = cloneDeep;
  public formatData = formatDataToMutationInput;
  public orderIds!: string[];
  public validInvoiceForm = true;
  public validInvoicePaymentMethodsForm = true;
  private invoice!: GQL_newInvoiceData_newInvoice;
  @Ref() public readonly invoiceRef!: Invoice;

  @SmartQuery<InvoicesNew, GQL_currentUnitPaymentMethods>({
    query: () => ALL_PAYMENT_METHODS,
    update: (data) => data.currentUnit.paymentMethods,
  }) private paymentMethods!: GQL_currentUnitPaymentMethods_currentUnit_paymentMethods[];

  @UnsavedChanges<InvoicesNew>({
    messages: {
      // i18n.t used instead of this.$t because function is async and component calling it might be destroyed, making 'this' undefined
      entity: i18n.t('Invoice.invoice'),
    },
    saveAndContinue() {
      return this.saveAndContinue();
    },
  }) private dirtyForm = false;

  created() {
    this.orderIds = this.$route.query.orderIds as string[];
  }

  private get validForm(): boolean {
    return this.validInvoiceForm && this.validInvoicePaymentMethodsForm;
  }

  private saveAndContinue() {
    return this.$apollo.mutate({
      mutation: CREATE_INVOICE,
      variables: this.formatData(this.invoice),
    }).then(() => {
      // i18n.t used instead of this.$t because function is async and component calling it might be destroyed, making 'this' undefined
      this.$sMessage.success(i18n.t('Message.saveSuccess'));
      return true;
    }).catch(() => {
      return false;
    });
  }

  private setInvoice(data: GQL_newInvoiceData) {
    if (!data.newInvoice) return;
    data.newInvoice.invoicePaymentMethods = (this.paymentMethods || []).map(pm => {
      return {
        ...pm,
        __typename: 'InvoicePaymentMethod',
        amount: new Decimal(0),
      };
    });
    data.newInvoice.legalNotes = data.newInvoice.unit.unitSetting.unitInvoiceSetting.legalNotes
      .map(noteKey =>
        AVAILABLE_LEGAL_NOTES
          .find(noteObj => noteObj.key === noteKey)
          ?.text,
      )
      .filter(v => !!v) as string[];
    data.newInvoice.customNote = data.newInvoice.unit.unitSetting.unitInvoiceSetting.customNote;
    this.invoice = this.cloneDeep(data.newInvoice);
    return data;
  }
}
